import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import FormHelperText from '@mui/joy/FormHelperText';
import Input from '@mui/joy/Input';
import Button from '@mui/joy/Button';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';

import Success from 'components/Success';
import Error from 'components/Error';


import useChatRoom from 'hooks/useChatRoom';
import useUserIdentity from 'hooks/useUserIdentity';
// import useUserIdentity from 'hooks/useUserIdentity';
// import useTeam from 'hooks/useTeam';

type ChatRoomCreateProps = {
    defaultName?: string,
    defaultDescription?: string,
};

const ChatRoomCreate = observer(( { defaultName='' }: ChatRoomCreateProps) => {
    const [name, setName] = useState(defaultName);
    const [description, _] = useState('');
    const [visibility, setVisibility] = useState('team');
    const { createChatRoom } = useChatRoom();
    const { currentIdentity } = useUserIdentity();
    const [saving, setSaving] = useState(false);
    const navigate = useNavigate();

    function doSave() {
        setSaving(true);
        createChatRoom(currentIdentity?.uuid, name, description, visibility)
            .then((room) => {
                if(!room) { throw "Failed to create room"; }
                Success('Created room!');
                navigate(`/chat/${room.uuid}`);
            })
            .catch((e) => {
                console.log('Error creating room', e);
                Error('There was an error creating the room');
            })
        .finally(() => setSaving(false));
    }

    // const { fetchMyTeam, getTeam, items } = useTeam();

    // // const { currentIdentity } = useUserIdentity();
    // // const [fetched, setFetched] = useState(false);
    // // const [teamName, setTeamName] = useState('');
    // // const [team, setTeam] = useState<TeamType|null>(getTeam(currentIdentity?.team));

    return (
        <Stack spacing={1}>
            <Typography level="title-lg">Create a new room</Typography>
            <FormControl>
                <FormLabel>Room Name</FormLabel>
                <Input
                    type="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                </FormControl>

                {/*
            <FormControl>
                <FormLabel>Purpose</FormLabel>
                <Textarea
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />
                </FormControl>
                  */}
            <FormControl>
                <FormLabel>Who can see this?</FormLabel>
                <Select defaultValue={visibility} onChange={(_, value) => value && setVisibility(value)}>
                <Option value="team">Team</Option>
                    <Option disabled value="private">Private (soon)</Option>
                </Select>
                <FormHelperText>You can add more people later</FormHelperText>
            </FormControl>

            <FormControl>
            <Button
                             disabled={(name.length == 0) || saving}
                    onClick={doSave}>Save</Button>
            </FormControl>
        </Stack>
    );
});
export default ChatRoomCreate;
